export interface AuditLogEntry {
  id: string;
  timestamp: string;
  userName: string;
  userRole: string;
  action: string;
  category: 'authentication' | 'document' | 'financial' | 'raffle' | 'admin' | 'system';
  details: string;
  ipAddress?: string;
}

const AUDIT_STORAGE_KEY = 'uzairue_audit_logs_store_v1';

export function getAuditLogs(): AuditLogEntry[] {
  try {
    const raw = localStorage.getItem(AUDIT_STORAGE_KEY);
    if (!raw) {
      const initial: AuditLogEntry[] = [
        {
          id: 'audit-1',
          timestamp: new Date().toLocaleString(),
          userName: 'High Chief Aliu Momoh',
          userRole: 'admin',
          action: 'System Initialization & Governance Bootstrap',
          category: 'system',
          details: 'Initialized Uzairue Kingdom Portal and CAMA 2020 financial governance structures.',
        },
        {
          id: 'audit-2',
          timestamp: new Date(Date.now() - 3600000).toLocaleString(),
          userName: 'Engr. Abdulazeez Haruna',
          userRole: 'authorizer',
          action: 'Official Document Authorized & Sealed',
          category: 'document',
          details: 'Authorized Proclamation document for ERUE Festival 2026 opening ceremonies.',
        },
        {
          id: 'audit-3',
          timestamp: new Date(Date.now() - 7200000).toLocaleString(),
          userName: 'Ikpemhi Oshioke',
          userRole: 'writer',
          action: 'Financial Ledger Entry Recorded',
          category: 'financial',
          details: 'Recorded philanthropic donation of ₦1,500,000 to account code 40-100-001.',
        },
      ];
      localStorage.setItem(AUDIT_STORAGE_KEY, JSON.stringify(initial));
      return initial;
    }
    return JSON.parse(raw);
  } catch (e) {
    return [];
  }
}

export function recordAuditLog(entry: Omit<AuditLogEntry, 'id' | 'timestamp'>): AuditLogEntry {
  const logs = getAuditLogs();
  const newEntry: AuditLogEntry = {
    ...entry,
    id: `audit-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
    timestamp: new Date().toLocaleString(),
    ipAddress: '192.168.1.104 (Secure Gateway)',
  };
  const updated = [newEntry, ...logs];
  try {
    localStorage.setItem(AUDIT_STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event('uzairue_audit_logged'));
  } catch (e) {
    console.error('Failed to record audit log', e);
  }
  return newEntry;
}
